import { render, staticRenderFns } from "./IndexSelector.vue?vue&type=template&id=629cde58&"
import script from "./IndexSelector.vue?vue&type=script&lang=js&"
export * from "./IndexSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports